export default "__VITE_ASSET__BaS1dNDu__"